export default "__VITE_ASSET__$Kwg23_z__"